<template>
  <div>
    <div v-for="document in documents" :key="document.id" class="row" :class="[isCerticiations ? '' : 'mb-1']">
      <div v-if="isCerticiations && document.documents && document.documents.length > 0" class="col-12">
        <div v-for="doc in document.documents" :key="doc.uuid" class="row mb-1">
          <div class="col-2">
            <a v-if="isDownloadable" :href="downloadLink(doc)" :download="doc.name" target="_blank">
              <i class="bushel-icon bushel-2x bushel-download" />
            </a>
            <i v-else class="fas fa-file fa-fw fa-2x" />
          </div>
          <div class="col-8 overflow-hidden">
            <p class="text-nowrap mb-0">
              {{ document.type }}
            </p>
            <div class="clearfix mb--half" />
            <span class="text-small text-light text-nowrap">
              {{ doc.name }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="!isCerticiations" class="col-12">
        <div class="row">
          <div class="col-2">
            <a v-if="isDownloadable" :href="downloadLink(document)" :download="document.name" target="_blank">
              <i class="bushel-icon bushel-2x bushel-download" />
            </a>
            <i v-else class="fas fa-file fa-fw fa-2x" />
          </div>
          <div class="col-8 overflow-hidden">
            <p class="text-nowrap mb-0">
              {{ document.label }}
            </p>
            <div class="clearfix mb--half" />
            <span class="text-small text-light text-nowrap">
              {{ document.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DownloadableFileList",
  props: {
    documents: { type: Array, required: true },
    isDownloadable: { type: Boolean, default: false },
    isCerticiations: { type: Boolean, default: false },
  },
  methods: {
    downloadLink(document) {
      const link = document.id ? `/b-api/docs/public-download/${document.uuid}` : document.file;
      return link;
    },
  },
};
</script>
<style scoped lang="scss">
.bushel-download {
  -webkit-transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  &:hover {
    opacity: 0.8;
  }
}
</style>
